export {};

import { trackEvent } from '../utils/analytics';

const mediaContainer = document.querySelector<HTMLElement>('[data-video-player]');
const video = mediaContainer?.querySelector<HTMLVideoElement>('video');
const playBtn = mediaContainer?.querySelector<HTMLElement>('.bottom-video-media-play');
const muteBtn = mediaContainer?.querySelector<HTMLElement>('.bottom-video-media-mute');
const cover = mediaContainer?.querySelector<HTMLElement>('.bottom-video-cover');

if (video) {
  video.muted = true;
  video.loop = true;
}

const loader = mediaContainer?.querySelector<HTMLElement>('.bottom-video-loader');

// preload="none": the file downloads on the first play, so show the standard loader until it starts
video?.addEventListener('playing', () => loader?.classList.remove('is-visible'));
video?.addEventListener('waiting', () => loader?.classList.add('is-visible'));

function togglePlayback(): void {
  if (!video || !playBtn) return;
  if (video.paused) {
    loader?.classList.add('is-visible');
    video.play().catch(() => loader?.classList.remove('is-visible'));
    playBtn.classList.add('playing');
    if (cover) cover.style.display = 'none';
    trackEvent('video_play', { section: 'bottom_video_section', trigger: 'user' });
  } else {
    video.pause();
    loader?.classList.remove('is-visible');
    playBtn.classList.remove('playing');
    if (cover) cover.style.display = 'none';
    trackEvent('video_pause', { section: 'bottom_video_section', trigger: 'user' });
  }
}

playBtn?.addEventListener('click', togglePlayback);
video?.addEventListener('click', togglePlayback);

// Product pages: click to play only, so the video file is never downloaded before the user asks for it.
const isProductPage = !!(window as unknown as { __productIdFromTemplate?: number | null }).__productIdFromTemplate;

if (mediaContainer && video && playBtn && !isProductPage) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio === 1) {
          video.play();
          playBtn.classList.add('playing');
          if (cover) cover.style.display = 'none';
          trackEvent('video_play', { section: 'bottom_video_section', trigger: 'autoplay' });
        } else {
          video.pause();
          playBtn.classList.remove('playing');
          trackEvent('video_pause', { section: 'bottom_video_section', trigger: 'autoplay' });
        }
      });
    },
    { threshold: 1.0 }
  );

  observer.observe(mediaContainer);
}

muteBtn?.addEventListener('click', () => {
  if (!video) return;
  video.muted = !video.muted;
  muteBtn.classList.toggle('muted');
});
